import testimonialSwiper from './js/testimonial-swiper';

import './testimonials.scss';